import React from 'react';
import { BounceLoader } from 'react-spinners';

import LoadingContainer from './styles';

const Loading = () => (
  <LoadingContainer>
    <BounceLoader
      sizeUnit="px"
      size={60}
      color="#2FAA33"
      loading
    />
  </LoadingContainer>
);

export default Loading;
